module.exports = __webpack_public_path__ + "static/media/5.593486c2.png";